import { render, staticRenderFns } from "./ContentTitle.vue?vue&type=template&id=19ba3de0"
import script from "./ContentTitle.vue?vue&type=script&lang=js"
export * from "./ContentTitle.vue?vue&type=script&lang=js"
import style0 from "./ContentTitle.vue?vue&type=style&index=0&id=19ba3de0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports